// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZjRjq","field":"styles_field__2rerh","fieldCol":"styles_fieldCol__2wwK8","diffCol":"styles_diffCol__1wK5d","diff":"styles_diff__1j6OD"};